import { useField } from 'formik'
import PropTypes from 'prop-types'

export const MySelectCurrency = ({ className, label, ...props }) => {
  const [field] = useField(props)
  return (
    <div
      className={`${className} absolute inset-y-0 right-0 flex items-center`}
    >
      <label className="sr-only" htmlFor={props.id || props.name}>
        {label}
      </label>
      <select
        {...field}
        {...props}
        className={
          'h-full rounded-md border-transparent bg-transparent py-0 pl-2 pr-7 text-gray-500 ' +
          'focus:border-gray-500 focus:ring-gray-500 sm:text-sm'
        }
      />
    </div>
  )
}
export default MySelectCurrency

MySelectCurrency.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  name: PropTypes.string,
}
